import React, { useContext, useEffect } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton } from '@mui/material';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import useStyles from './styles';

function AlertMessage() {
  const classes = useStyles();
  const {
    successMessage,
    errorMessage,
    infoMessage,
    warningMessage,
    setErrorMessage,
    setInfoMessage,
    setSuccessMessage,
    setWarningMessage,
  } = useContext(GeneralContext);

  useEffect(() => {
    setTimeout(() => {
      if (successMessage) {
        setSuccessMessage('');
      }
      if (errorMessage) {
        setErrorMessage('');
      }
      if (infoMessage) {
        setInfoMessage('');
      }
      if (warningMessage) {
        setWarningMessage('');
      }
    }, 7000);
    if (successMessage) {
      setErrorMessage('');
      setInfoMessage('');
      setWarningMessage('');
    } else if (errorMessage) {
      setSuccessMessage('');
      setInfoMessage('');
      setWarningMessage('');
    } else if (infoMessage) {
      setSuccessMessage('');
      setErrorMessage('');
      setWarningMessage('');
    } else if (warningMessage) {
      setSuccessMessage('');
      setErrorMessage('');
      setInfoMessage('');
    }
  }, [successMessage, errorMessage, infoMessage, warningMessage]);

  return (
    <>
      {successMessage && (
        <Alert
          className={`${classes.alert} ${classes.colorSuccess}`}
          severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setSuccessMessage('');
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert
          className={`${classes.alert} ${classes.colorError}`}
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setErrorMessage('');
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {errorMessage}
        </Alert>
      )}
      {infoMessage && (
        <Alert
          className={`${classes.alert} ${classes.colorInfo}`}
          severity="info"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setInfoMessage('');
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {infoMessage}
        </Alert>
      )}
      {warningMessage && (
        <Alert
          className={`${classes.alert} ${classes.colorWarning}`}
          severity="warning"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setWarningMessage('');
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {warningMessage}
        </Alert>
      )}
    </>
  );
}

export default AlertMessage;
